import { FunctionComponent } from 'react'
import { Box } from '@mui/material'
import {
  Controller,
  useFormContext,
  // eslint-disable-next-line import/named
  Path,
  // eslint-disable-next-line import/named
  PathValue,
  // eslint-disable-next-line import/named
  ControllerRenderProps,
  // eslint-disable-next-line import/named
  ControllerFieldState,
  // eslint-disable-next-line import/named
  UseFormStateReturn,
  // eslint-disable-next-line import/named
  FieldValues,
} from 'react-hook-form'

export type RenderPropsType = {
  field: ControllerRenderProps<FieldValues, any>
  fieldState: ControllerFieldState
  formState: UseFormStateReturn<FieldValues>
  formValues: FieldValues
}

export type GRID_FORM_CONFIG_ELEMENT_T<DataType> = {
  id: number
  controllerName: Path<DataType>
  type?: string
  defaultValue?: PathValue<DataType, any>
  RenderElement: FunctionComponent<any>
  renderProps: (props: RenderPropsType) => Record<string, unknown>
}

export type GRID_FORM_CONFIG_T<DataType> = GRID_FORM_CONFIG_ELEMENT_T<DataType>[][]

type FormBlockProps<DataType> = {
  formFieldConfig: GRID_FORM_CONFIG_T<DataType>
  sx?: {}
}

export const FormBlock = <T,>({ formFieldConfig, sx }: FormBlockProps<T>): any => {
  const { control, getValues } = useFormContext()
  const formValues = getValues()

  return formFieldConfig?.map((rowElements, rowId: number) => {
    const sortedElements = [...rowElements].sort((a, b) => {
      const firstIndex = rowElements.indexOf(a)
      const secondIndex = rowElements.indexOf(b)
      return firstIndex - secondIndex
    })

    return (
      <Box key={rowId} sx={sx}>
        {sortedElements.map((element, elementIndex) => {
          if (!element) {
            return <></>
          }
          return (
            <Box key={elementIndex}>
              {
                <Controller
                  render={({ field, fieldState, formState, ...props }) => {
                    const calculateProps = {
                      ...props,
                      ...element.renderProps({
                        field,
                        fieldState,
                        formState,
                        formValues,
                      }),
                      ...field,
                      error: fieldState?.invalid ? true : undefined,
                      ...(fieldState?.error?.message
                        ? { helperText: fieldState?.error?.message }
                        : {}),
                      ...(element.type === 'checkbox' ? { checked: Boolean(field.value) } : {}),
                    }
                    return <element.RenderElement {...calculateProps}></element.RenderElement>
                  }}
                  name={element.controllerName}
                  control={control}
                  defaultValue={element.defaultValue}
                />
              }
            </Box>
          )
        })}
      </Box>
    )
  })
}
